module.exports = __webpack_public_path__ + "static/media/column.8bf1b149.svg";